module.exports = __webpack_public_path__ + "img/vrbo.57673373.png";